import React from 'react';

import { Outlet } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import './LayoutWithSidebar.css'; // Asegúrate de importar tu CSS

const LayoutWithSidebar: React.FC = () => {
  return (
    <div className="layout-with-sidebar">
      <Sidebar />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export { LayoutWithSidebar as LayoutSide };
